import { AlertCircle, CheckCircle, Clock, HelpCircle } from "lucide-react";

export const VALID_SERVICES = [
  "salesforce",
  "hubspot",
  "marketo",
  "gongio",
] as const;

export interface FivetranConnection {
  id: string;
  service_name: string;
  service_display: string;
  environment: string;
  fivetran_connection_id: string;
  setup_state: "incomplete" | "connected" | "broken" | "unknown";
  created_at: string;
  updated_at: string;
}

export const getStatusIcon = (
  setupState: FivetranConnection["setup_state"],
) => {
  switch (setupState) {
    case "connected":
      return <CheckCircle className="h-4 w-4 text-success" />;
    case "broken":
      return <AlertCircle className="h-4 w-4 text-destructive" />;
    case "incomplete":
      return <Clock className="h-4 w-4 text-warning" />;
    default:
      return <HelpCircle className="h-4 w-4 text-muted-foreground" />;
  }
};

export const getStatusBadgeVariant = (
  setupState: FivetranConnection["setup_state"],
) => {
  switch (setupState) {
    case "connected":
      return "team-emerald" as const;
    case "broken":
      return "destructive" as const;
    case "incomplete":
      return "team-amber" as const;
    default:
      return "default" as const;
  }
};

export const getStatusLabel = (
  setupState: FivetranConnection["setup_state"],
) => {
  switch (setupState) {
    case "connected":
      return "Connected";
    case "broken":
      return "Broken";
    case "incomplete":
      return "Setup Required";
    default:
      return "Unknown";
  }
};

export const SERVICE_LABELS = {
  salesforce: "Salesforce",
  hubspot: "HubSpot",
  marketo: "Marketo",
  gongio: "Gong",
} as const;

export const SERVICE_DESCRIPTIONS = {
  salesforce:
    "Connect your Salesforce CRM to sync accounts, contacts, leads, and opportunities.",
  hubspot:
    "Connect your HubSpot CRM to sync contacts, companies, deals, and marketing data.",
  marketo:
    "Connect your Marketo platform to sync leads, campaigns, and marketing activities.",
  gongio: "Connect your Gong platform to sync call recordings.",
} as const;
